// Main
import { MainState } from './main/main.state';
import { MainEffects } from './main/main.effects';

// FilterTop
import { FilterTopState } from './filter-top/filter-top.state';
import { FilterTopEffects } from './filter-top/filter-top.effects';

// Search
import { SearchState } from './search/search.state';
import { SearchEffects } from './search/search.effects';

// Product
import { ProductState } from './product/product.state';
import { ProductEffects } from './product/product.effects';

// Checkout
import { CheckoutState } from './checkout/checkout.state';
import { CheckoutEffects } from './checkout/checkout.effects';

export interface DashboardState {
    main: MainState;
    search: SearchState;
    filterTop: FilterTopState;
    product: ProductState;
    checkout: CheckoutState;
}

export const dashboardEffects = [
    MainEffects,
    SearchEffects,
    FilterTopEffects,
    ProductEffects,
    CheckoutEffects
];

